import { onboardingSlides } from '../src/utils/config/onboardingConfig';
import { whatsNewSlides } from './utils/config/WhatsNewSlides/whatsNew062026';
import { equipmentFeatureSlides } from './utils/config/featureConfig';

export const generateSlidesConfig = (type: string, activeFlags: string[]) => {
  switch (type) {
    case 'equipment_feature':
      return equipmentFeatureSlides;
    case 'whats_new':
      return (
        whatsNewSlides
          .filter(
            val => !val.featureFlag || activeFlags.includes(val.featureFlag)
          )
          // We normally only want to return the four most recent slides but for June 2026, we are going to return five slides.
          .slice(0, 5)
      );
    case 'onboarding':
      return onboardingSlides;
    default:
      return onboardingSlides;
  }
};
